import { Stack } from '@mui/material';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { EquipmentContext } from 'Context';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { EquipmentNotAllowed } from './EquipmentNotAllowed';
import { EquipmentRecentOrders } from './EquipmentRecentOrders';
import { CustomMetaTitle, Header2 } from 'Components';

export const EquipmentMain = () => {
  const { availableItems, isLoading, loader } = useContext(EquipmentContext);

  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.Equipment].title} />
      <LinkReturnToMain />

      {isLoading ? (
        loader
      ) : (
        <Stack pb={2} maxWidth='960px'>
          {availableItems?.items?.length === 0 ? (
            <EquipmentNotAllowed />
          ) : (
            <EquipmentRecentOrders />
          )}
        </Stack>
      )}
    </>
  );
};
